import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class UserService {
    constructor(private http: HttpClient) { }

    addAddress(address) {
        return this.http.post<any>(`${environment.apiUrl}/users/add-address`, address);
    }

    updateAddress(address) {
        return this.http.post<any>(`${environment.apiUrl}/users/update-address`, address);
    }

    removeAddress(addressId) {
        return this.http.post<any>(`${environment.apiUrl}/users/remove-address`, addressId);
    }
    setDefaultAddress(addressId) {
        return this.http.post<any>(`${environment.apiUrl}/users/set-default-address`, addressId);
    }
    checkEmail(email) {
        return this.http.post<any>(`${environment.apiUrl}/users/check-email`, { email: email });
    }

    update(user) {
        return this.http.post<any>(`${environment.apiUrl}/users/update`, user);
    }

    delete() {
        return this.http.post<any>(`${environment.apiUrl}/users/delete-account`, {});
    }

    changeType() {
        return this.http.post<any>(`${environment.apiUrl}/users/set-type-regular`, {});
    }

    setLanguage(preferences) {
        return this.http.post<any>(`${environment.apiUrl}/users/set-language`, preferences);
    }

    setCurrency(id) {
        return this.http.post<any>(`${environment.apiUrl}/users/set-currency/`, { _id: id });
    }

    setCountry(id) {
        return this.http.post<any>(`${environment.apiUrl}/users/set-country/`, { _id: id });
    }

    setCity(city) {
        return this.http.post<any>(`${environment.apiUrl}/users/set-city/`, city);
    }

    emailVendorUser(params) {
        return this.http.post<any>(`${environment.apiUrl}/users/emailVendor/`, params);
    }

}
